<template>
  <div class="space-y-6" :style="guideStep == 3 || guideStep == 31 || guideStep == 7 ? { zIndex: 100, position: 'relative' } : { position: 'relative' }">
    <loading :active="!this.showLinkAccount"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <loading :active="!this.showTiktokLinkAccount"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div v-if="!hideTeachingButton && firstLoginStatue == 'N' && active == 0" class="d2-hidden-mobile px-2 text-sm col-span-2 text-right absolute right-2" style="z-index:1; margin-top: 0px;">
      <div class="px-2 text-sm leading-8 float-right">
        <a href="#" class="text-gray-700 underline" @click="openFirstLogin()">{{lang['components']['LinkAccount']['Index']['teaching_button']}}</a>
      </div>
      <img :src="lightImg" class="h-8 w-8 float-right" />
    </div>

    <TabView class="tabview-custom d2-home-tabview" v-model:activeIndex="active" style="margin-top:-4px;">
      <TabPanel>
        <template #header>
            <img width="25" src="https://private.autoturn.net/img/facebook_icon.png">
            <!-- <i class="pi pi-calendar mr-2"></i> -->
            <span>{{lang['components']['LinkAccount']['Index']['fb_tag']}}</span>
        </template>
        <div class="text-gray-700 text-xl">
          <div v-if="user_info.user_id == null || user_info.user_id == ''" class="d2-link-account-row">
            <div class="flex flex-wrap items-center gap-2">
              <button
                class="d2-btn d2-btn-primary d2-btn-sm"
                @click="loginFacebook()"
              >
                <i class="pi pi-external-link" style="fontSize: 0.8rem"></i>
                {{lang['components']['LinkAccount']['Index']['login_button_text']}}
              </button>
            </div>
          </div>
          <div v-else class="d2-link-account-row">
            <div class="flex flex-wrap items-center gap-2">
              {{lang['components']['LinkAccount']['Index']['link_adaccount_text']}}
              <button
                class="d2-btn d2-btn-primary d2-btn-sm"
                :class="{ 'ring-4 border-blue-400': guideStep === 3 }"
                @click="linkAccount()"
              >
                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                {{lang['components']['LinkAccount']['Index']['link_adaccount_button_text']}}
              </button>
            </div>
            <span class="text-sm text-gray-500 leading-8">
            <!-- <span class="ml-2 text-sm text-gray-500 leading-8"> -->
              <span v-if="accountListLength <= 0">{{lang['components']['LinkAccount']['Index']['link_adaccount_info']}}</span>
            </span>
          </div>
        </div>
        <Account
          v-if="user_info.user_id != null && user_info.user_id != ''"
          v-bind:lang="lang"
          v-for="(item, index) in accountList"
          :key="index"
          :accountInfo="item"
          @childConnectAccount="connectAccountFinish"
        />
      </TabPanel>
      <!-- ========== TikTok 分頁 - 暫時隱藏 ========== -->
      <TabPanel v-if="false">
        <template #header>
            <img width="23" src="https://private.autoturn.net/img/tiktok_icon.png">
            <!-- <i class="pi pi-calendar mr-2"></i> -->
            <span>{{lang['components']['LinkAccount']['Index']['tiktok_tag']}}</span>
        </template>
        <div v-if="user_info.tiktok_user_id == null || user_info.tiktok_user_id == ''" class="d2-link-account-row">
          <div class="flex flex-wrap items-center gap-2">
            <button
              class="d2-btn d2-btn-sm" style="background: #1a1a2e; color: #fff;"
              @click="loginTiktok()"
            >
              <i class="pi pi-external-link" style="fontSize: 0.8rem"></i>
              {{tiktokLang['components']['LinkAccount']['Index']['login_button_text']}}
            </button>
          </div>
        </div>
        <div v-else class="d2-link-account-row">
          <div class="flex flex-wrap items-center gap-2">
            <span class="text-xl">{{tiktokLang['components']['LinkAccount']['Index']['link_adaccount_text']}}</span>
            <button
              class="d2-btn d2-btn-sm" style="background: #1a1a2e; color: #fff;"
              @click="linkTiktokAccount()"
            >
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
              {{tiktokLang['components']['LinkAccount']['Index']['link_adaccount_button_text']}}
            </button>
          </div>
        </div>
        <TiktokAccount
          v-if="user_info.tiktok_user_id != null && user_info.tiktok_user_id != ''"
          v-bind:lang="tiktokLang"
          v-for="(item, index) in tiktokAccountList"
          :key="index"
          :accountInfo="item"
          @childTiktokConnectAccount="tiktokConnectAccountFinish"
        />
      </TabPanel>
      <!-- ========== TikTok 分頁結束 ========== -->
    </TabView>
  </div>
  <ConnectAccountDialog v-bind:lang="lang" v-model:show="showModal" :guideStep="guideStep" :topOpen="topOpen" @childConnectAccount="connectAccountFinish" @nextStep="nextStep"/>
  <TiktokConnectAccountDialog v-bind:lang="tiktokLang" v-model:show="tiktokShowModal" :topOpen="tiktokTopOpen" @childTiktokConnectAccount="tiktokConnectAccountFinish"/>
  <div v-if="guideStep == 31 || guideStep == 7" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0); z-index: 101;"></div>
</template>

<script>
  import lightImg from "@/assets/light.png";
  import Account from './Account.vue'
  import TiktokAccount from '@/components/TikTokLinkAccount/Account.vue'
  import ConnectAccountDialog from '@/components/Dialog/ConnectAccountDialog.vue'
  import TiktokConnectAccountDialog from '@/components/TikTokDialog/ConnectAccountDialog.vue'
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";
  import axios from 'axios'
  import Qs from 'qs'

  import TabView from 'primevue/tabview';
  import TabPanel from 'primevue/tabpanel';

  export default {
    name: 'LinkAccount',
    components: {
      Account,
      TiktokAccount,
      ConnectAccountDialog,
      TiktokConnectAccountDialog,
      Loading,
      TabView,
      TabPanel
    },
    props: {
      guideStep: {
        type: Number,
        default: -1
      },
      hideTeachingButton: {
        type: Boolean,
        default: false
      },
      lang: {
        type: Object
      },
      tiktokLang: {
        type: Object
      },
      firstLoginStatue: {
        type: String
      },
      transmitFbNum: {
        type: String,
        default: ''
      },
      transmitTiktokNum: {
        type: String,
        default: ''
      },
      user_info: {
        type: Object
      },
    },
    data() {
      return {
        lightImg: lightImg,
        showModal: false,
        tiktokShowModal: false,
        accountList: null,
        accountListLength: 0,
        tiktokAccountList: [],
        tiktokAccountListLength: 0,
        topOpen: false,
        tiktokTopOpen: false,
        showLinkAccount: false,
        showTiktokLinkAccount: false,
        active: null,
        // accountList: [
        //   {
        //     info: {
        //       name: 'Taipei Time',
        //       id: '1234567789',
        //     },
        //     fanPageList: [
        //       { id: '43789578971', title: 'Future Lab1', checked: true},
        //       { id: '43789578972', title: 'Future Lab2', checked: false},
        //       { id: '43789578973', title: 'Future Lab3', checked: false},
        //       { id: '43789578974', title: 'Future Lab4', checked: false},
        //     ]
        //   },
        //   {
        //     info: {
        //       name: 'Taipei Time 222',
        //       id: '0987654321',
        //     },
        //     fanPageList: [
        //       { id: '43789578971', title: 'Future Lab1', checked: true},
        //       { id: '43789578972', title: 'Future Lab2', checked: false},
        //       { id: '43789578973', title: 'Future Lab3', checked: false},
        //       { id: '43789578974', title: 'Future Lab4', checked: false},
        //     ]
        //   }
        // ]
      }
    },
    created() {
      //console.log('index list');
      this.showLinkAccount = false
      this.showTiktokLinkAccount = false

      axios
        .post('https://www.autoturn.net/api/adaccount.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('adaccount response:');
            // console.log(response.data.return_data);
            // self.first_name = response.data.firstName;
            // this.first_name = response.data.firstName
            this.accountList = [];
            this.accountListLength = 0;

            if(response.data.return_data != '' && response.data.return_data != null && typeof response.data.return_data != 'undefined'){
              this.accountList = response.data.return_data;
              this.accountListLength = response.data.return_data.length;
            }

            if(typeof response.data.adaccount_length != 'undefined'){
              this.$emit('adaccountLength', response.data.adaccount_length);
            }

            if(typeof response.data.page_length != 'undefined'){
              this.$emit('pageLength', response.data.page_length);
            }

            this.$emit('connectedAdaccountLength', this.accountListLength);
            this.$emit('connectedPageLength', this.getConnectedPageLength(this.accountList));
          }

          this.showLinkAccount = true;
          // console.log('created showLinkAccount');
          // console.log(this.showLinkAccount);
        });

      axios
        .post('https://www.autoturn.net/api/tiktok/campaign/in_use_advertiser_list.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            //console.log('tiktok adaccount response:');
            //console.log(response.data);
            // console.log(response.data.return_data);
            // console.log(response.data.return_data.length);
            // self.first_name = response.data.firstName;
            // this.first_name = response.data.firstName
            this.tiktokAccountList = [];
            this.tiktokAccountListLength = 0;

            if(response.data.return_data != '' && response.data.return_data != null && typeof response.data.return_data != 'undefined'){
              this.tiktokAccountList = response.data.return_data;
              this.tiktokAccountListLength = response.data.return_data.length;
            }

            if(typeof response.data.tiktokAdaccount_length != 'undefined'){
              this.$emit('tiktokAdaccountLength', response.data.adaccount_length);
            }

            if(typeof response.data.page_length != 'undefined'){
              this.$emit('tiktokPageLength', response.data.page_length);
            }
          }

          this.showTiktokLinkAccount = true
        });

      this.active = 0;
      if(this.$route.params.id == 't'){
        this.active = 1;
      }

      // this.showLinkAccount = true;
      //console.log('created showLinkAccount');
      //console.log(this.showLinkAccount);
    },
    watch:{
      'guideStep': function(v){
        //console.log('account index guideStep');
        //console.log(v);

        if(v == 4){
          this.showModal = true;
        }

        if(v == -1 || v == 7){
          this.showModal = false;
        }
      },
      'transmitTiktokNum': function(v){
        if(v != '' && v != null){
          //console.log('transmitFbNum');
          //console.log(this.transmitFbNum);
          //console.log('v');
          //console.log(v);

          let tmpTransmitFbNum = this.transmitFbNum.split('_');
          let tmpTransmitTiktokNum = v.split('_');

          if((this.$route.params.type == 't') || (parseInt(tmpTransmitFbNum[0]) == 0 && parseInt(tmpTransmitTiktokNum[0]) > 0)){
            this.active = 1;

            var todayForm = new Date();
            var yearForm = todayForm.getFullYear();
            var dateForm = String(todayForm.getDate()).padStart(2, '0');
            var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
            var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

            let get_value = 't_'+yearForm + monthForm + dateForm + timeForm;

            this.$emit('childChangeLinkType', get_value);

            //console.log('get childChangeLinkType');
            //console.log(get_value);
          }
        }
      },
      'active': function(v){
        //console.log('active');
        //console.log(v);

        if(v == 1){
          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 't_'+yearForm + monthForm + dateForm + timeForm;

          this.$emit('childChangeLinkType', get_value);
        } else {
          var todayForm = new Date();
          var yearForm = todayForm.getFullYear();
          var dateForm = String(todayForm.getDate()).padStart(2, '0');
          var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
          var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

          let get_value = 'f_'+yearForm + monthForm + dateForm + timeForm;

          this.$emit('childChangeLinkType', get_value);
        }

        this.$emit('childActive', v);
      },
      'tiktokLang':function(v){
        //console.log('tiktokLang');
        //console.log(v);
      }
    },
    methods: {
      loginFacebook(){
        //console.log('click loginFacebook');

        var scope = "email,ads_management,ads_read,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,read_insights,pages_messaging,catalog_management,business_management,leads_retrieval";

        // window.open("https://www.facebook.com/v7.0/dialog/oauth?client_id=878235949197736&redirect_uri=https://www.autoturn.net/index.php/login/view/fb_login_api&state=https://www.autoturn.net/index.php/login/view/fb_login_api&scope="+scope+"&auth_type=rerequest", "fb_login", config = "toolbar=no,height=650,width=700");

        let hash = this.$route.params.id;
        let type = this.$route.params.type;
        let parameter_array = {};

        parameter_array['active'] = 'vueLogin';
        parameter_array['hash'] = hash;
        parameter_array['redirect_uri'] = "https://www.autoturn.net/index.php/login/view/fb_login_api";

        let to_api_state = JSON.stringify(parameter_array);
        let config = "toolbar=no,height=650,width=700";

        var newWindow = window.open("https://www.facebook.com/v7.0/dialog/oauth?client_id=878235949197736&redirect_uri=https://www.autoturn.net/index.php/login/view/fb_login_api&state="+to_api_state+"&scope="+scope+"&auth_type=rerequest", "fb_login", config);

        let _lang = this.lang;

        $('#login_type').val('fb');

        var timer = setInterval(function() {
            //console.log('�`�N�� fb newWindow');
            //console.log(newWindow);
            if(newWindow.closed) {
                clearInterval(timer);
                //console.log('�w����');
                axios
                  .post('https://www.autoturn.net/api/tiktok/account_check.php', Qs.stringify({
                    s_code: hash,
                    type: 'fb'
                  }))
                  .then((response) => {
                    //console.log('linkAccount account_check response');
                    //console.log(response);


                    if(response.data.status == 'success'){
                      //console.log('fb _lang');
                      //console.log(_lang);

                      Swal.fire({
                        icon: response.data.status,
                        title: _lang['components']['LinkAccount']['Index']['loginFacebook']['axios']['swal_title'],
                        text: response.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: _lang['components']['LinkAccount']['Index']['loginFacebook']['axios']['button_text'],
                        timer: 5000
                      }).then((result) => {
                        if (result.isConfirmed) {
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        }

                        if (result.dismiss === Swal.DismissReason.timer) {
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        }
                      })
                    } else {
                      Swal.fire(
                        _lang['components']['LinkAccount']['Index']['loginFacebook']['axios']['swal_title'],
                        response.data.info,
                        response.data.status
                      );
                    }
                  });
            }
        }, 1000);

        // Swal.fire(
        //   '�s��Facebook�b��',
        //   '�s�\��q�д��ݡC',
        //   'info'
        // );

        // let hash = this.$route.params.id;

        // var scope = "email,ads_management,ads_read,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_ads,read_insights,pages_messaging,catalog_management,business_management,leads_retrieval";

        // let parameter_array = {};

        // parameter_array['active'] = 'vueLogin';
        // parameter_array['hash'] = hash;
        // parameter_array['redirect_uri'] = "https://www.autoturn.net/index.php/login/view/fb_login_api";

        // let to_api_state = JSON.stringify(parameter_array);
        // let config = "toolbar=no,height=650,width=700";

        // var newWindow = window.open("https://www.facebook.com/v7.0/dialog/oauth?client_id=878235949197736&redirect_uri=https://www.autoturn.net/index.php/login/view/fb_login_api&state="+to_api_state+"&scope="+scope+"&auth_type=rerequest", "fb_login", config);

        // var timer = setInterval(function() {
        //     console.log('�`�N�� fb newWindow');
        //     console.log(newWindow);
        //     if(newWindow.closed) {
        //         clearInterval(timer);
        //         console.log('�w����');
        //         axios
        //           .post('https://www.autoturn.net/api/tiktok/account_check.php', Qs.stringify({
        //             s_code: hash,
        //             type: 'fb'
        //           }))
        //           .then((response) => {
        //             console.log('loginFacebook account_check response');
        //             console.log(response);
        //           });
        //     }
        // }, 1000);
      },
      linkAccount(){
        let member_hash = this.$route.params.id;
        let type = this.$route.params.type;

        axios
          .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
            s_code: member_hash,
            route_type: type,
            active: 'member',
          }))
          .then((caResponse) => {

            if(caResponse.data.status == 'error'){
              if(caResponse.data.type == 2){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  if (result.isConfirmed) {
                    // Swal.fire('Saved!', '', 'success')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/"+type+"/"+member_hash;
                  } else if (result.isDenied) {
                    // Swal.fire('Changes are not saved', '', 'info')
                    this.allPageLoading = true
                    window.location.href = "https://private.autoturn.net/"+type+"/"+member_hash;
                  }
                })
              } else if(caResponse.data.type == 3){
                Swal.fire({
                  icon: caResponse.data.status,
                  title: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['swal_title'],
                  text: caResponse.data.info,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['confirm_button']
                  // denyButtonText: `Don't save`,
                }).then((result) => {
                  // if (result.isConfirmed) {
                  //   // Swal.fire('Saved!', '', 'success')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // } else if (result.isDenied) {
                  //   // Swal.fire('Changes are not saved', '', 'info')
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }

                  // if (result.dismiss === Swal.DismissReason.timer) {
                  //   this.allPageLoading = true
                  //   window.location.href = "http://localhost:8080/"+member_hash;
                  // }
                })
              } else {
                Swal.fire(
                          this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['swal_title'],
                          caResponse.data.info,
                          caResponse.data.status
                        )
              }
            }

            if(caResponse.data.status == 'warning'){
              Swal.fire({
                icon: 'warning',
                title: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Index']['linkAccount']['axios']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.showModal = true;

                  if(this.guideStep == 3){
                    this.$emit('nextStep');
                  }
                }
              });
            }

            if(caResponse.data.status == 'success'){
              this.showModal = true;

              if(this.guideStep == 3){
                this.$emit('nextStep');
              }
            }

            if(caResponse.data.status == 'login'){
              Swal.fire({
                icon: 'error',
                title: this.lang['components']['LinkAccount']['Index']['linkAccount']['login']['swal_title'],
                text: this.lang['components']['LinkAccount']['Index']['linkAccount']['login']['swal_text'],
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['components']['LinkAccount']['Index']['linkAccount']['login']['confirm_button']
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                } else if (result.isDenied) {
                  window.location.href = "https://www.autoturn.net/index.php/index/logout?o=1";
                }
              })
            }
          });
      },
      loginTiktok(){
        //console.log('click loginTiktok');

        // Swal.fire(
        //   '�s��Tiktok�b��',
        //   '�s�\��q�д��ݡC',
        //   'info'
        // );

        let hash = this.$route.params.id;
        let type = this.$route.params.type;
        let parameter_array = {};

        parameter_array['active'] = 'vueLogin';
        parameter_array['hash'] = hash;
        parameter_array['redirect_uri'] = "https://www.autoturn.net/index.php/login/view/tiktok_login_api";

        let to_api_state = JSON.stringify(parameter_array);
        let config = "toolbar=no,height=650,width=700";

        var newWindow = window.open("https://business-api.tiktok.com/portal/auth?app_id=7287526286434500610&state="+to_api_state+"&redirect_uri=https%3A%2F%2Ftest.autoturn.net%2Finside%2Findex.php%2Flogin%2Fview%2Ftiktok_login_api", "tiktok_login", config);

        let _lang = this.lang;

        var timer = setInterval(function() {
            //console.log('�`�N�� tiktok newWindow');
            //console.log(newWindow);
            if(newWindow.closed) {
                clearInterval(timer);
                //console.log('�w����');
                axios
                  .post('https://www.autoturn.net/api/tiktok/account_check.php', Qs.stringify({
                    s_code: hash,
                    type: 'tiktok'
                  }))
                  .then((response) => {
                    //console.log('linkAccount account_check response');
                    //console.log(response);


                    if(response.data.status == 'success'){
                      //console.log('tiktok _lang');
                      //console.log(_lang);

                      Swal.fire({
                        icon: response.data.status,
                        title: _lang['components']['LinkAccount']['Index']['loginTiktok']['axios']['swal_title'],
                        text: response.data.info,
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: _lang['components']['LinkAccount']['Index']['loginTiktok']['axios']['button_text'],
                        timer: 5000
                      }).then((result) => {
                        if (result.isConfirmed) {
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        } else if (result.isDenied) {
                          // Swal.fire('Changes are not saved', '', 'info')
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        }

                        if (result.dismiss === Swal.DismissReason.timer) {
                          this.allPageLoading = true
                          window.location.href = "https://private.autoturn.net/"+type+"/"+hash;
                        }
                      })
                    } else {
                      Swal.fire(
                        _lang['components']['LinkAccount']['Index']['loginTiktok']['axios']['swal_title'],
                        response.data.info,
                        response.data.status
                      );
                    }
                  });

                // axios
                //   .post('https://www.autoturn.net/udnapi/login/check_member.php', Qs.stringify({
                //     s_code: hash,
                //   }))
                //   .then((response) => {
                //     console.log('linkAccount check_member response');
                //     console.log(response);
                //   });
            }
        }, 1000);
      },
      linkTiktokAccount(){
        //console.log('click linkTiktokAccount');

        this.tiktokShowModal = true;
      },
      connectAccountFinish(v){
        this.$emit('childLinkAccount', v);

        let tmpDataType = v.split('_');

        // console.log('connectAccountFinish:'+v);
        // console.log(tmpDataType);

        if(tmpDataType[0] == 'true'){
          // console.log(tmpDataType[0]);
          const selectedPageLength = Number(tmpDataType[2]) || 0;
          if (selectedPageLength > 0) {
            this.$emit('connectedAdaccountLength', 1);
            this.$emit('connectedPageLength', selectedPageLength);
          }
          this.showLinkAccount = false

          axios
            .post('https://www.autoturn.net/api/adaccount.php', Qs.stringify({
              s_code: this.$route.params.id
            }))
            .then((response) => {
              console.log(response.data.return_data);
              if(response.data.status == 'success'){
                // console.log('adaccount response:');
                // console.log(response.data.return_data);
                // console.log(response.data.return_data.length);
                // self.first_name = response.data.firstName;
                // this.first_name = response.data.firstName
                this.accountList = response.data.return_data;
                this.accountListLength = response.data.return_data.length;
                const connectedPageLength = this.getConnectedPageLength(this.accountList);
                this.$emit('connectedAdaccountLength', Math.max(this.accountListLength, selectedPageLength > 0 ? 1 : 0));
                this.$emit('connectedPageLength', Math.max(connectedPageLength, selectedPageLength));
              }

              this.showLinkAccount = true
              // console.log('connectAccountFinish showLinkAccount');
              // console.log(this.showLinkAccount);
            });


        }
      },
      tiktokConnectAccountFinish(v){
        //console.log('tiktokConnectAccountFinish');
        //console.log(v);

        let tmpDataType = v.split('_');

        //console.log('tiktokConnectAccountFinish:'+v);
        //console.log(tmpDataType);

        if(tmpDataType[0] == 'true'){
          this.showLinkAccount = false

          axios
            .post('https://www.autoturn.net/api/tiktok/campaign/in_use_advertiser_list.php', Qs.stringify({
              s_code: this.$route.params.id
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                //console.log('tiktok adaccount response:');
                //console.log(response.data);
                // console.log(response.data.return_data);
                // console.log(response.data.return_data.length);
                // self.first_name = response.data.firstName;
                // this.first_name = response.data.firstName

                this.tiktokAccountList = response.data.return_data;
                this.tiktokAccountListLength = response.data.return_data.length;

                this.showLinkAccount = true
              }
            });
        }
      },
      nextStep(v) {
        // console.log('linkaccount index');
        // console.log(v);
        // if(v != 4 && v != 5){
        //   var todayForm = new Date();
        //   var yearForm = todayForm.getFullYear();
        //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
        //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        //   todayForm = yearForm + monthForm + dateForm + timeForm;

        //   this.topOpen = 'true_'+v+'_'+todayForm;
        // } else {
          this.$emit('nextStep', v);
        // }
      },
      getConnectedPageLength(accountList) {
        if (!Array.isArray(accountList)) {
          return 0;
        }

        return accountList.reduce((total, account) => {
          if (!Array.isArray(account.fanPageList)) {
            return total;
          }

          return total + account.fanPageList.filter((page) => this.isPageConnected(page)).length;
        }, 0);
      },
      isPageConnected(page) {
        return page.checked === true || page.checked === 'true' || page.checked === 1 || page.checked === '1'
          || page.in_use === true || page.in_use === 'true' || page.in_use === 1 || page.in_use === '1';
      },

      openFirstLogin(){
        //console.log('linkaccount openFirstLogin');

        var todayForm = new Date();
        var yearForm = todayForm.getFullYear();
        var dateForm = String(todayForm.getDate()).padStart(2, '0');
        var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
        var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

        let get_value = 'Y_'+yearForm + monthForm + dateForm + timeForm;

        this.$emit('childOpenFirstLogin', get_value);

        axios
          .post('https://www.autoturn.net/api/adaccount.php', Qs.stringify({
            s_code: this.$route.params.id
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              //console.log('adaccount response:');
              //console.log(response.data);
              //console.log(response.data.return_data);
              //console.log(response.data.return_data.length);
              // self.first_name = response.data.firstName;
              // this.first_name = response.data.firstName

              if(typeof response.data.adaccount_length != 'undefined'){
                this.$emit('adaccountLength', response.data.adaccount_length);
              }

              if(typeof response.data.page_length != 'undefined'){
                this.$emit('pageLength', response.data.page_length);
              }
            }

            this.showLinkAccount = true
          });
      }
    }
  }
</script>

<style scope>

</style>
